import { Grid, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { selectAllPreviousSurveyAnswers } from "store/reducers/survey/SurveySlice";
import {
  getSelectedLearningResourceInterestValues,
  sortPersonalizedResourceTopicsByInterests
} from "utils/v3/learningResourceUtils";
import { flattenSurveyAnswers } from "utils/v3/surveyUtils";
import HeroCardGridSytles from "./PersonalizedResources.styles";
import ContentResolver from "../ContentResolver";
import ImageWithFooterCardSource from "../ImageWithFooterCardSource";

const PersonalizedResources = (props) => {
  const { material } = props;
  const { topics = [], more } = material;
  const previousSurveyAnswers = useSelector(selectAllPreviousSurveyAnswers);
  const selectedInterests = getSelectedLearningResourceInterestValues(
    flattenSurveyAnswers(previousSurveyAnswers || [])
  );
  const orderedTopics = sortPersonalizedResourceTopicsByInterests(
    topics,
    selectedInterests
  );

  const classes = HeroCardGridSytles();

  const renderCards = (cards = []) => {
    return cards.map((card, index) => {
      return (
        <Grid item xs={12} sm={6} lg={3} key={index} className={classes.gridItem}>
          <ImageWithFooterCardSource {...card} href={card.href} source={card.source} />
        </Grid>
      );
    });
  };

  const renderTopic = (topic, index) => {
    const { headline, description, cards } = topic;

    const maybeHeader = headline ? (
      <Typography variant="body_strong_lg" className={classes.headline}>
        <ContentResolver content={headline} />
      </Typography>
    ) : null;

    const maybeDescription = description ? (
      <Typography variant="body">
        <ContentResolver content={description} />
      </Typography>
    ) : null;

    return (
      // this is repeatable a topic - START
      <Grid
        container
        className={classes.container}
        justifyContent="center"
        key={topic.topicId || index}
      >
        <Grid item xs={12}>
          {maybeHeader || maybeDescription ? (
            <div className={classes.headerContainer}>
              <div className={classes.headerText}>{maybeHeader}</div>
              <div className={classes.headerDesc}>{maybeDescription}</div>
            </div>
          ) : null}
          <Grid container spacing={2}>
            {renderCards(cards)}
          </Grid>
        </Grid>
      </Grid>
      // this is repeatable a topic - END
    );
  };

  const maybeMore = more ? (
    <Grid container className={classes.container} justifyContent="center">
      <Grid item xs={12} className={classes.containerMore}>
        <div className={classes.headerContainer}>
          <div>
            <Typography variant="body_strong_lg" className={classes.headline}>
              <ContentResolver content={more.title} />
            </Typography>
          </div>
          <div>
            <Typography variant="body">
              <ContentResolver content={more.description} />
            </Typography>
          </div>
        </div>
      </Grid>
    </Grid>
  ) : null;

  return (
    <div>
      {orderedTopics.map(renderTopic)}
      {maybeMore}
    </div>
  );
};

export default PersonalizedResources;
